import seedrandom from 'seedrandom'
import MobileDetect from 'mobile-detect';
import React from 'react'
import axios from 'axios'

export const md = new MobileDetect(window.navigator.userAgent);
export const random = seedrandom('hello friends');

export const setDocumentHeight = () => {
  if (md.os() === 'iOS' && md.version('iOS') >= 12) {
    setTimeout(() => {
      document.documentElement.style.height = '100.1vh';
      setTimeout(() => {
        document.documentElement.style.height = '100vh';
      }, 100);
    }, 100);
  }
};

export const formatContent = (content) => {
  return content.split('\n').map(((c, index)=>(<p key={index} className={"line"}>{c}</p>)))
}

// window.wxTimer = null
//
// if(window.wx){
//   window.wx.error(function (res) {
//     window.Raven.captureMessage(JSON.stringify({
//       res,
//       location: window.location,
//       lastWXConfigUrl: window.lastWXConfigUrl
//     }))
//   })
// }

// export const setupWx = () => {
//   if(window.wxTimer){
//     clearTimeout(window.wxTimer)
//   }
//   window.wxTimer = setTimeout(()=>{
//     window.wxTimer = null
//     const ua = navigator.userAgent.toLowerCase();
//     const isWeixin = ua.indexOf('micromessenger') != -1;
//     if (!isWeixin) {
//       console.error("not weixin")
//     }
//     // const url = window.location.protocol+'//'+window.location.host+window.location.pathname
//     const url = window.location.href
//     window.lastWXConfigUrl = url
//     return axios.post(`/auth/wxconfig`, {url}).then(({data})=>{
//       window.wx.config({
//         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//         appId: data.appId, // 必填，公众号的唯一标识
//         timestamp:data.timestamp , // 必填，生成签名的时间戳
//         nonceStr: data.nonceStr, // 必填，生成签名的随机串
//         signature: data.signature, // 必填，签名，见附录1
//         jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//       });
//       return window.wx
//     }).catch(error=>{
//       console.log(error)
//     })
//   }, 500)
// }

// export const setupWx = () => {
//   const ua = navigator.userAgent.toLowerCase();
//   const isWeixin = ua.indexOf('micromessenger') != -1;
//   if (!isWeixin) {
//     console.error("not weixin")
//   }
//   const url = window.location.href
//   window.lastWXConfigUrl = url
//   return axios.post(`/auth/wxconfig`, {url}).then(({data})=>{
//     return new Promise((resolve, reject)=>{
//       window.wx.config({
//         debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//         appId: data.appId, // 必填，公众号的唯一标识
//         timestamp:data.timestamp , // 必填，生成签名的时间戳
//         nonceStr: data.nonceStr, // 必填，生成签名的随机串
//         signature: data.signature, // 必填，签名，见附录1
//         jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//         success: function (res) {
//           resolve(window.wx)
//         },
//         fail: function (res) {
//           window.Raven.captureMessage(JSON.stringify({
//             res,
//             location: window.location,
//             lastWXConfigUrl: url
//           }))
//           reject(res)
//         }
//       });
//     })
//   })
// }

export const setupWx = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isWeixin = ua.indexOf('micromessenger') != -1;
  if (!isWeixin) {
    console.error("not weixin")
  }
  // const url = window.location.protocol+'//'+window.location.host+window.location.pathname
  const url = window.location.href
  return axios.post(`/auth/wxconfig`, {url}).then(({data})=>{
    window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp:data.timestamp , // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      success: function (res) {
        console.log('success', res)
      },
      fail: function (res) {
        window.Raven.captureMessage(JSON.stringify({
          res,
          location: window.location,
          lastWXConfigUrl: url
        }))
        console.log('fail', res)
      }
    });
    return window.wx
  }).catch(error=>{
    console.log(error)
  })
}




// WEBPACK FOOTER //
// ./src/utils.js